function LoginHeader() {
  return (
    <div className="sm:mx-auto sm:w-full sm:max-w-md mb-4">
      <img
        className="mx-auto h-[100px] w-auto object-contain"
        src={`${import.meta.env.BASE_URL}images/logoDarkSvg.svg`}
        alt="Logo"
      />
    </div>
  );
}

export default LoginHeader;
